// extracted by mini-css-extract-plugin
export default {"tabGroup":"_1ug9NPjHCxNUA2MaBIxKwX","badge":"_6GzRFDUIBUIIkvKspq5O6o"};